const CART_FIRST_ADD_PREFIX = 'cart_first_add_'

export function getCartFirstAddKey(cartId) {
  return `${CART_FIRST_ADD_PREFIX}${cartId}`
}

export function setCartFirstAddTime(cartId, isoDate) {
  if (!cartId || !isoDate || typeof window === 'undefined') return
  const key = getCartFirstAddKey(cartId)
  if (!localStorage.getItem(key)) {
    localStorage.setItem(key, isoDate)
  }
}

export function clearCartFirstAddTime(cartId) {
  if (!cartId || typeof window === 'undefined') return
  localStorage.removeItem(getCartFirstAddKey(cartId))
}

export function clearAllCartFirstAddTimes() {
  if (typeof window === 'undefined') return

  const keysToRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key?.startsWith(CART_FIRST_ADD_PREFIX)) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key))
}
